import { cn } from '@/lib/utils';

/**
 * AvailabilityDot — Atom
 * Green/grey presence indicator for provider availability.
 * Green = clinically available (status-success), Grey = unavailable.
 */

interface AvailabilityDotProps {
  available: boolean;
  className?: string;
}

export function AvailabilityDot({ available, className }: AvailabilityDotProps) {
  return (
    <span
      className={cn(
        'w-3 h-3 rounded-full border-2 border-surface-card',
        available ? 'bg-status-success' : 'bg-grey-400',
        className
      )}
      role="status"
      aria-label={available ? 'Available' : 'Unavailable'}
    />
  );
}
